import {
	alpha,
	ButtonBase,
	CircularProgress,
	Stack,
	type StackProps,
	useTheme,
} from "@mui/material";
import { Camera } from "lucide-react";
import type { FC } from "react";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = Omit<StackProps, "children"> & {
	isUploading: boolean;
	name: string;
	onClick: () => void;
	photo?: string;
};

export const ProfileAvatar: FC<Props> = ({
	isUploading,
	name,
	onClick,
	photo,
	sx,
	...stackProps
}) => {
	const theme = useTheme();

	return (
		<Stack
			component={ButtonBase}
			alignItems="center"
			justifyContent="center"
			onClick={onClick}
			disabled={isUploading}
			{...stackProps}
			sx={[
				{
					width: 80,
					height: 80,
					borderRadius: "50%",
					overflow: "visible",
					position: "relative",
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
		>
			<InitialsAvatar
				key={photo}
				name={name}
				photo={photo}
				background={theme.gradients.avatar}
				initialsColor={theme.palette.darkmodeText.white}
			/>
			{isUploading && (
				<Stack
					position="absolute"
					top={0}
					left={0}
					right={0}
					bottom={0}
					alignItems="center"
					justifyContent="center"
					borderRadius="50%"
					bgcolor={alpha(theme.palette.darkmodeText.black, 0.5)}
				>
					<CircularProgress
						size={40}
						sx={{ color: theme.palette.darkmodeText.white }}
					/>
				</Stack>
			)}
			<Stack
				position="absolute"
				bottom={0}
				right={0}
				alignItems="center"
				justifyContent="center"
				p="3px"
				borderRadius="50%"
				bgcolor={theme.palette.blue[600]}
				border={`2px solid ${theme.palette.background.paper}`}
			>
				<Camera
					size={theme.iconSize.sm}
					color={theme.palette.darkmodeText.white}
					strokeWidth={2}
				/>
			</Stack>
		</Stack>
	);
};
